module.exports = __webpack_public_path__ + "img/lobby-2.8558766d.png";